// ============================================================
// Constantes Centralizadas — Bryemma
// Single source of truth para valores de negocio
// ============================================================

// ── Tipos de Vehículo ────────────────────────────────────────────────────────
export const VEHICLE_TYPES = {
  MOTO: 'moto',
  CARRO: 'carro',
};

export const VEHICLE_TYPE_LABELS = {
  [VEHICLE_TYPES.MOTO]: 'Moto',
  [VEHICLE_TYPES.CARRO]: 'Carro',
};

export const VEHICLE_TYPE_OPTIONS = [
  { value: VEHICLE_TYPES.MOTO, label: 'Moto' },
  { value: VEHICLE_TYPES.CARRO, label: 'Carro' },
];

// ── Estados del Conductor ─────────────────────────────────────────────────────
export const DRIVER_STATUSES = {
  PENDING: 'pending',
  ACTIVE: 'active',
  SUSPENDED: 'suspended',
  REJECTED: 'rejected',
};

export const DRIVER_STATUS_LABELS = {
  [DRIVER_STATUSES.PENDING]: 'Pendiente',
  [DRIVER_STATUSES.ACTIVE]: 'Activo',
  [DRIVER_STATUSES.SUSPENDED]: 'Suspendido',
  [DRIVER_STATUSES.REJECTED]: 'Rechazado',
};

export const DRIVER_STATUS_VARIANT = {
  [DRIVER_STATUSES.PENDING]: 'warning',
  [DRIVER_STATUSES.ACTIVE]: 'success',
  [DRIVER_STATUSES.SUSPENDED]: 'secondary',
  [DRIVER_STATUSES.REJECTED]: 'primary',
};

// ── Estados de Tracking del Conductor ─────────────────────────────────────────
export const TRACKING_STATUSES = {
  ONLINE: 'online',
  OFFLINE: 'offline',
  ON_TRIP: 'on_trip',
};

export const TRACKING_STATUS_LABELS = {
  [TRACKING_STATUSES.ONLINE]: 'En línea',
  [TRACKING_STATUSES.OFFLINE]: 'Desconectado',
  [TRACKING_STATUSES.ON_TRIP]: 'En viaje',
};

// ── Estados de Servicio ───────────────────────────────────────────────────────
export const SERVICE_STATUSES = {
  SEARCHING: 'searching',
  DRIVER_ASSIGNED: 'driver_assigned',
  IN_PROGRESS: 'in_progress',
  AWAITING_CONFIRMATION: 'awaiting_confirmation',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  NO_DRIVERS_AVAILABLE: 'no_drivers_available',
};

export const SERVICE_STATUS_LABELS = {
  [SERVICE_STATUSES.SEARCHING]: 'Buscando conductor',
  [SERVICE_STATUSES.DRIVER_ASSIGNED]: 'Conductor asignado',
  [SERVICE_STATUSES.IN_PROGRESS]: 'En curso',
  [SERVICE_STATUSES.AWAITING_CONFIRMATION]: 'Esperando confirmación',
  [SERVICE_STATUSES.COMPLETED]: 'Completado',
  [SERVICE_STATUSES.CANCELLED]: 'Cancelado',
  [SERVICE_STATUSES.NO_DRIVERS_AVAILABLE]: 'Sin conductores disponibles',
};

// ── Tipos de Servicio ─────────────────────────────────────────────────────────
export const SERVICE_TYPES = {
  RIDE: 'ride',
  DELIVERY: 'delivery',
  ERRAND: 'errand',
};

export const SERVICE_TYPE_LABELS = {
  [SERVICE_TYPES.RIDE]: 'Viaje',
  [SERVICE_TYPES.DELIVERY]: 'Delivery',
  [SERVICE_TYPES.ERRAND]: 'Recado',
};

// ── Métodos de Pago ───────────────────────────────────────────────────────────
export const PAYMENT_METHODS = {
  PAGO_MOVIL: 'pago_movil',
  TRANSFERENCIA: 'transferencia',
  EFECTIVO: 'efectivo',
  BINANCE: 'binance',
  ZELLE: 'zelle',
  DIVISAS: 'divisas',
};

export const PAYMENT_METHOD_LABELS = {
  [PAYMENT_METHODS.PAGO_MOVIL]: 'Pago Móvil',
  [PAYMENT_METHODS.TRANSFERENCIA]: 'Transferencia',
  [PAYMENT_METHODS.EFECTIVO]: 'Efectivo',
  [PAYMENT_METHODS.BINANCE]: 'Binance',
  [PAYMENT_METHODS.ZELLE]: 'Zelle',
  [PAYMENT_METHODS.DIVISAS]: 'Divisas',
};

export const PAYMENT_METHOD_OPTIONS = [
  { value: PAYMENT_METHODS.PAGO_MOVIL, label: 'Pago Móvil' },
  { value: PAYMENT_METHODS.BINANCE, label: 'Binance' },
  { value: PAYMENT_METHODS.EFECTIVO, label: 'Efectivo' },
  { value: PAYMENT_METHODS.ZELLE, label: 'Zelle' },
];

// ── Estados de Pago ───────────────────────────────────────────────────────────
export const PAYMENT_STATUSES = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  VERIFIED: 'verified',
  SETTLED: 'settled',
  DISPUTED: 'disputed',
  PAID: 'paid',
  CANCELLED: 'cancelled',
};

export const PAYMENT_STATUS_LABELS = {
  [PAYMENT_STATUSES.PENDING]: 'Pendiente',
  [PAYMENT_STATUSES.CONFIRMED]: 'Confirmado',
  [PAYMENT_STATUSES.VERIFIED]: 'Verificado',
  [PAYMENT_STATUSES.SETTLED]: 'Liquidado',
  [PAYMENT_STATUSES.DISPUTED]: 'En disputa',
  [PAYMENT_STATUSES.PAID]: 'Pagado',
  [PAYMENT_STATUSES.CANCELLED]: 'Cancelado',
};

// ── Tipos de Documento ────────────────────────────────────────────────────────
export const DOCUMENT_TYPES = {
  CEDULA: 'cedula',
  LICENSE: 'license',
  VEHICLE_TITLE: 'vehicle_title',
  INSURANCE: 'insurance',
  RIF: 'rif',
  OTHER: 'other',
};

export const DOCUMENT_TYPE_LABELS = {
  [DOCUMENT_TYPES.CEDULA]: 'Cédula de Identidad',
  [DOCUMENT_TYPES.LICENSE]: 'Licencia de Conducir',
  [DOCUMENT_TYPES.VEHICLE_TITLE]: 'Título de Propiedad',
  [DOCUMENT_TYPES.INSURANCE]: 'Seguro Vehicular',
  [DOCUMENT_TYPES.RIF]: 'RIF',
  [DOCUMENT_TYPES.OTHER]: 'Otro',
};

export const DOCUMENT_TYPE_OPTIONS = [
  { value: DOCUMENT_TYPES.CEDULA, label: 'Cédula de Identidad' },
  { value: DOCUMENT_TYPES.LICENSE, label: 'Licencia de Conducir' },
  { value: DOCUMENT_TYPES.VEHICLE_TITLE, label: 'Título de Propiedad' },
  { value: DOCUMENT_TYPES.INSURANCE, label: 'Seguro Vehicular' },
  { value: DOCUMENT_TYPES.RIF, label: 'RIF' },
];

// ── Estados de Documento ──────────────────────────────────────────────────────
export const DOCUMENT_STATUSES = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
};

export const DOCUMENT_STATUS_LABELS = {
  [DOCUMENT_STATUSES.PENDING]: 'Pendiente',
  [DOCUMENT_STATUSES.APPROVED]: 'Aprobado',
  [DOCUMENT_STATUSES.REJECTED]: 'Rechazado',
};

// ── Roles ─────────────────────────────────────────────────────────────────────
export const ROLES = {
  PASSENGER: 'passenger',
  DRIVER: 'driver',
  SUPPORT: 'support',
  ADMIN: 'admin',
  SUPER_ADMIN: 'super_admin',
};

export const ROLE_LABELS = {
  [ROLES.PASSENGER]: 'Pasajero',
  [ROLES.DRIVER]: 'Conductor',
  [ROLES.SUPPORT]: 'Soporte',
  [ROLES.ADMIN]: 'Administrador',
  [ROLES.SUPER_ADMIN]: 'Super Admin',
};

// Niveles de acceso (jerarquía)
export const ROLE_LEVELS = {
  [ROLES.PASSENGER]: 1,
  [ROLES.DRIVER]: 2,
  [ROLES.SUPPORT]: 3,
  [ROLES.ADMIN]: 4,
  [ROLES.SUPER_ADMIN]: 5,
};

// ── Estados de Ticket de Soporte ──────────────────────────────────────────────
export const TICKET_STATUSES = {
  OPEN: 'open',
  IN_PROGRESS: 'in_progress',
  RESOLVED: 'resolved',
  CLOSED: 'closed',
};

export const TICKET_STATUS_LABELS = {
  [TICKET_STATUSES.OPEN]: 'Abierto',
  [TICKET_STATUSES.IN_PROGRESS]: 'En Progreso',
  [TICKET_STATUSES.RESOLVED]: 'Resuelto',
  [TICKET_STATUSES.CLOSED]: 'Cerrado',
};

// ── Niveles de Prioridad ─────────────────────────────────────────────────────
export const PRIORITY_LEVELS = {
  LOW: 'low',
  NORMAL: 'normal',
  HIGH: 'high',
  URGENT: 'urgent',
};

export const PRIORITY_LEVEL_LABELS = {
  [PRIORITY_LEVELS.LOW]: 'Baja',
  [PRIORITY_LEVELS.NORMAL]: 'Normal',
  [PRIORITY_LEVELS.HIGH]: 'Alta',
  [PRIORITY_LEVELS.URGENT]: 'Urgente',
};

// ── Configuración Geográfica ──────────────────────────────────────────────────
export const DEFAULT_MAP_CENTER = { lat: 8.8872, lng: -64.2444 }; // El Tigre, Anzoátegui
export const DEFAULT_SEARCH_RADIUS_KM = 5;
export const AVG_SPEED_KMH = 25; // moto en zona urbana
export const SERVICE_SEARCH_TIMEOUT_SEC = 180; // 3 minutos para timeout de búsqueda
export const SEARCH_DECISION_WINDOW_SEC = 60; // 1 minuto visible para decidir si se cancela la solicitud
export const SERVICE_SEARCH_DIAGNOSTIC_WINDOW_SEC = 3600; // 1 hora: ventana para explicar solicitudes expiradas

// ── Pesos para Delivery ──────────────────────────────────────────────────────
export const WEIGHT_OPTIONS = [
  { value: 0, label: 'Sin paquete (viaje)' },
  { value: 2, label: 'Liviano — menos de 5 kg' },
  { value: 10, label: 'Mediano — 5 a 15 kg' },
  { value: 20, label: 'Pesado — más de 15 kg' },
];

// ── Estados de Alerta de Pánico ───────────────────────────────────────────────
export const PANIC_ALERT_STATUSES = {
  ACTIVE: 'active',
  RESOLVED: 'resolved',
};

export const PANIC_ALERT_STATUS_LABELS = {
  [PANIC_ALERT_STATUSES.ACTIVE]: 'Activa',
  [PANIC_ALERT_STATUSES.RESOLVED]: 'Resuelta',
};

// ── Categorías de Servicio (iconos) ──────────────────────────────────────────
// Nota: los iconos se importan donde se usan, aquí solo los identificadores
export const SERVICE_CATEGORY_KEYS = {
  RIDE: 'ride',
  DELIVERY: 'delivery',
  ERRAND: 'errand',
};
